import React from 'react';
// components
import Modal from 'shared/modals/Modal';
import LoadingModal from 'shared/loading/LoadingModal';
// fetch
import { TabBar, Tab } from 'shared/layout/Tabs';
import {FormikLabel} from '../../../shared/components/forms';
import useLocationInfoById from './useLocationInfoById';
// consts
import { requestStatuses } from 'shared/../constants/store';

const LocationInfoModal = ({isOpen, close, locationId}) => {
    const { status, error, location } = useLocationInfoById(locationId);

    const isLoading = status === requestStatuses.INIT || status === requestStatuses.PENDING;
    return (
        <Modal isOpen handleClose={close} containerStyle='medium'>
            <div className='modal-header'>
                <h5 className='modal-title' id='carrierModal'>
                    Location Info {location ? ` - ${location.name}` : ''}
                </h5>
                <button className='button large close' onClick={close}/>
            </div>
            <div className='modal-body-content' style={{padding: '1rem'}}>
                <LoadingModal isOpen={isLoading} isNested={true}/>
                {location ? (
                    <React.Fragment>
                      <TabBar>
                        <Tab key="additionalInformation" title="Additional Information">
                          <section className='formik-form rows'>
                            <fieldset className='formik-section'>
                                <legend>Information</legend>
                                <div className='formik-row'>
                                    <div className="formik-wrapper wrapper-three-column">
                                          <FormikLabel
                                              label='Hours of Operation'
                                              value={location.hoursOfOperation}
                                          />
                                      </div>
                                      <div className="formik-wrapper wrapper-three-column">
                                          <FormikLabel
                                              label='Appointment required'
                                              value={location.appointmentRequired === true ? 'Yes' : 'No'}
                                          />
                                      </div>
                                      <div className="formik-wrapper wrapper-three-column">
                                          <FormikLabel
                                              label='Allowed Delivery Type'
                                              value={location.allowedDeliveryType}
                                          />
                                      </div>
                                  </div>
                                  <div className='formik-row'>
                                      <div className='formik-wrapper wrapper-one-column'>
                                          <FormikLabel
                                              label='Additional Information'
                                              value={location.additionalInformation}
                                          />
                                      </div>
                                  </div>
                              </fieldset>
                          </section>
                        </Tab>
                        <Tab key="driverInstructions" title="Driver Instructions">
                          <section className='formik-form rows'>
                              <fieldset className='formik-section'>
                                  <legend>Instructions</legend>
                                  <div className='formik-row' style={{marginBottom: 0}}>
                                      {location.driverInstructions}
                                  </div>
                              </fieldset>
                          </section>
                        </Tab>
                      </TabBar>
                    </React.Fragment>
                ) : null}
                {error && <div className='feedback'>No info available</div>}
            </div>
            <div className='modal-footer toolbar toolbar--xxs'>
                <div className='toolbar--column toolbar--right'>
                    <button type='button' className='button large primary text-align--center margin--none--xxs'
                            onClick={close}>
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default LocationInfoModal;
